import { render, staticRenderFns } from "./CnicPromoListComponent.vue?vue&type=template&id=17ecb5eb"
import script from "./CnicPromoListComponent.vue?vue&type=script&lang=js"
export * from "./CnicPromoListComponent.vue?vue&type=script&lang=js"
import style0 from "./CnicPromoListComponent.vue?vue&type=style&index=0&id=17ecb5eb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports